'use strict';

function PennyDropServiceConfirmation() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [];

  this.presenter = null;
  this.action = null;
  this.successCallback = function () {}; // When penny drop confirmation is successful
  this.failureCallback = function () {}; // When penny drop confirmation is not successful
  this.onSubmitCallback = function () {}; // When penny drop confirmation attempted (form submit)

  this.elementGroups = {};
  this._elementGroupClasses = {
    depositInput: { className: 'js--deposit-input' },
    loader: { className: 'penny-drop-service-confirmation__loader' },
    form: { className: 'penny-drop-service-confirmation__form' },
    mainContent: { className: 'penny-drop-service-confirmation__content' },
    cta: { className: 'penny-drop-service-confirmation__cta' }
  };
  this._fieldsInteractedWith = [];

  this.init = function () {
    // Analytics
    var portalContext = $('#Portal').mogo();
    this.analytics = new Analytics();
    this.analytics.update(portalContext.analyticsData, portalContext);

    this.node.addClass('loader penny-drop-service-confirmation');
    var loaderContainer = document.createElement('div');
    loaderContainer.addClass('loader penny-drop-service-confirmation__loader');
    var loader = document.createElement('div');
    loader.className = 'progress-infinite';
    loaderContainer.appendChild(loader);
    this.node.appendChild(loaderContainer);
    $(this.node).show();

    var params = {
      url: '/member/components/penny-drop-service-confirmation',
      contentType: 'text/html',
      dataType: 'html',
      success: this._onLoadUISuccess.bind(this),
      error: this._onLoadUIError.bind(this)
    };
    $.ajax(params);
  };

  this.initAllReady = function () {};

  this._onLoadUISuccess = function (data) {
    // Insert into document
    $(this.node).append(data);

    // cache group element references
    for (var elementName in this._elementGroupClasses) {
      var className = this._elementGroupClasses[elementName].className;

      this.elementGroups[elementName] = this.node.getElementsByClassName(className);
    }

    // Parse components
    this.node.children[1].mogo().parse();

    mogo.ready(this._setupFormHandlers.bind(this));
  };

  this._onLoadUIError = function () {
    this.failureCallback({ errors: [{ code: 404, key: 'resource_not_found' }] }, 404);
  };

  this._setupFormHandlers = function () {
    // Submit handler
    $(this.node).find('form').on('submit', this._validateForm.bind(this));

    // Input handlers
    for (var i = 0; i < this.elementGroups.depositInput.length; i++) {
      var inputField = this.elementGroups.depositInput[i];
      inputField.addEventListener('focus', this._onFieldInteraction.bind(this));
      inputField.addEventListener('blur', this._validateDepositAmount.bind(this));
      inputField.addEventListener('keydown', function (event) {
        if (event.key == 'Enter') {
          // Pass-through
        } else if (event.key != 'Backspace' && event.key != 'ArrowLeft' && event.key != 'ArrowRight' && event.key != 'Tab' && event.key != '.' && isNaN(parseInt(event.key))) {
          event.preventDefault();
        }
      });
    }

    $(this.elementGroups.loader).addClass('hide');
    $(this.elementGroups.form).removeClass('hide');
  };

  this._validateDepositAmount = function (event) {
    var amount = event.target.value;
    if (isNaN(amount)) {
      event.target.mogo().showErrorLabel(true, 'Please enter the amount in the format of "0.00".');
    } else if (amount) {
      var value = parseFloat(amount).toFixed(2);
      if (value.length < 4) value += '0';
      event.target.value = value;
      event.target.mogo().hideError();
    }
  };

  this._validateForm = function (event) {
    event.preventDefault();
    $(this.elementGroups.cta).mogo().setDisabledLoadState();

    var pennyDropsAmounts = [];

    this._fieldInteractedWith = [];

    var oneErrorMessageShown = false;
    for (var i = 0; i < this.elementGroups.depositInput.length; i++) {
      var inputField = this.elementGroups.depositInput[i];
      if (inputField.classList.contains('error') || inputField.mogo().val() === '') {
        $(this.elementGroups.cta).mogo().removeDisabledLoadState();
        this.analytics.pushEvent('form-errors', { FormErrors: [inputField.name] });
        if (inputField.mogo().val() === '' && !oneErrorMessageShown) {
          inputField.mogo().showErrorLabel(true, 'Please enter the amount in the format of "0.00"');
          oneErrorMessageShown = true;
        }
        this.failureCallback({ errors: [{ code: 400, key: 'number_lte' }] }, 400);
        return;
      }
      pennyDropsAmounts.push(parseFloat(inputField.value));
    }

    this.onSubmitCallback();
    this._performVerificationAction(pennyDropsAmounts);
  };

  this._performVerificationAction = function (pennyDropsAmounts) {
    var _this = this;

    this.presenter.performAction(this.action, { amounts: pennyDropsAmounts }, function (data, response) {
      $(_this.elementGroups.cta).mogo().removeDisabledLoadState();
      if (response === 200) {
        if (data.penny_drop.status === 'confirmed') {
          _this._pushFormSubmitAnalytics();
          _this._fieldsInteractedWith = [];
          if (typeof _this.successCallback === 'function') {
            _this.successCallback(data, response);
          }
        } else if (data.penny_drop.status === 'failed') {
          _this.analytics.pushEvent('form-errors', { FormErrors: ['Deposit one, Deposit two'] });
          if (typeof _this.failureCallback === 'function') {
            if (data.penny_drop.confirmation_attempts === 3) {
              _this.failureCallback({
                errors: [{
                  code: 400,
                  key: 'member_service_maximum_penny_drop_confirmation_attempts_reached'
                }]
              }, 400);
            } else {
              _this.failureCallback(data, response);
            }
          }
        } else if (data.penny_drop.confirmation_attempts < 3) {
          _this._showWrongAmountsError(data, true);
          _this.failureCallback({ errors: [{ code: 400, key: 'incorrect_attempt' }] }, 400);
        }
      } else if (response === 400 && data.errors) {
        if (data.errors[0].key === 'member_service_maximum_penny_drop_confirmation_attempts_reached') {
          _this.failureCallback(data, response);
        } else if (data.errors[0].key === 'invalid_type') {
          var fieldIndex = data.errors[1].property.split('.')[1];
          var inputField = _this.elementGroups.depositInput[fieldIndex];
          var inputFieldMogo = inputField.mogo();
          inputFieldMogo.showError();
          inputFieldMogo.showErrorLabel();
          inputField.addEventListener('focus', _this._hideFormErrors.bind(_this));
          _this.failureCallback(data, response);
        } else if (data.errors[0].key === 'number_lte') {
          _this._showWrongAmountsError(data, false);
          _this.failureCallback(data, response);
        }
      }
    });
  };

  this._showWrongAmountsError = function (data, showNumAttempts) {
    var attempts = 0;
    if (data.penny_drop) {
      attempts = isNaN(data.penny_drop.confirmation_attempts) ? 0 : data.penny_drop.confirmation_attempts;
    }
    for (var i = 0; i < this.elementGroups.depositInput.length; i++) {
      var inputField = this.elementGroups.depositInput[i];
      var inputFieldMogo = inputField.mogo();
      inputFieldMogo.showError();
      if (i === 0) {
        inputFieldMogo.showErrorLabel(true, 'Hey, you entered the wrong amounts.' + (showNumAttempts ? ' You have ' + (3 - attempts) + ' attempt' + (3 - attempts > 1 ? 's' : '') + ' left.' : ''));
      }
      inputField.addEventListener('focus', this._hideFormErrors.bind(this));
    }
    this.analytics.pushEvent('form-errors', { FormErrors: ['Deposit one, Deposit two'] });
  };

  this._hideFormErrors = function () {
    for (var i = 0; i < this.elementGroups.depositInput.length; i++) {
      var inputField = this.elementGroups.depositInput[i];
      var inputFieldMogo = inputField.mogo();
      inputFieldMogo.hideError();
      inputField.removeEventListener('focus', this._hideFormErrors.bind(this));
    }
  };

  this._pushFormSubmitAnalytics = function () {
    var formAnalyticsID = $(this.node).find('form').data('analytics-id');
    this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
  };

  this._onFieldInteraction = function (event) {
    event.target.dataset.interacted = 'true';
    var form = this.node.getElementsByTagName('form')[0];
    var fields = form.elements;
    this._fieldsInteractedWith = [];
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        this._fieldsInteractedWith.push(fields[i].name);
      }
    }
  };

  this._pushAbandonmentData = function () {
    if (this._fieldsInteractedWith.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._fieldsInteractedWith.join(', ')]
      });
    }
  };

  this.destroy = function () {
    this._pushAbandonmentData();
  };
}